import request from '../utils/request';
import qs from "qs";

export function getAdminList(param) {
    return request({
        url: '/admin/search-admin',
        method: 'GET',
        params: param
    })
}

export function getAdminOption(param) {
    return request({
        url: '/admin/admin-option',
        method: 'GET',
        params: param
    })
}

export function saveAdmin(data, id) {
    return request({
        url: '/admin/admin/' + id,
        method: 'PUT',
        data
    })
}

export function addAdmin(data) {
    return request({
        url: '/admin/admin',
        method: 'POST',
        data
    })
}

export function deleteAdmin(id) {
    return request({
        url: '/admin/admin/' + id,
        method: 'DELETE'
    })
}

export function setAdminPass(pass, id) {
    return request({
        url: '/admin/admin/' + id + '/pass',
        method: 'PUT',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify({"password":pass})
    })
}


export function setAdminIsValidate(id, value) {
    return request({
        url: '/admin/admin/' + id + '/is-validate/'+ value,
        method: 'PUT',
    })
}

export function getAdminRole() {
    return request({
        url: '/admin/search-admin-role',
        method: 'GET',
    })
}

export function setAdminIsRole(id, role_id) {
    return request({
        url: '/admin/admin/' + id + '/role/'+ role_id,
        method: 'PUT'
    })
}
